import { FC } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { COMMISSION_TOOL_BASE_PATH, CONTRACT_SETTING_PATH } from '../../constants';
import { contractSettingFilterKeys } from './list/contract-setting-listing-page.hook';
import { ContractSettingListingPage } from './list/contract-setting-listing-page.screen';
import ContractSettingDetailPage from './form/contract-setting-detail-page';
import ContractSettingImportPage from './import/contract-setting-import-page';

export const contractSettingPath = `${COMMISSION_TOOL_BASE_PATH}${CONTRACT_SETTING_PATH}`;

const ContractSettingRoutes: FC = () => {
  return (
    <Switch>
      <Redirect exact from={contractSettingPath} to={`${contractSettingPath}/list`} />
      <PruRoute
        exact
        path={`${contractSettingPath}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={contractSettingFilterKeys}>
            <ContractSettingListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${contractSettingPath}/create`} component={ContractSettingDetailPage} />
      <PruRoute exact path={`${contractSettingPath}/edit/:id`} component={ContractSettingDetailPage} />
      <PruRoute exact path={`${contractSettingPath}/import`} component={ContractSettingImportPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default ContractSettingRoutes;
